<template>
<v-main>
    <div><v-btn @click="getPdf">{{printStr}}</v-btn></div>
    <div class="resingblock">
        <h2 class="resingTitle">{{text.title}}</h2>
        <div class="resingSubBlock">
            <span class="resingCd">{{text.userCd}}<br>{{form.userCode}}</span>
            <span class="resingSimei">{{text.simei}}<br>{{form.userName}}</span>
        </div>
        <div class="resingMainBlock">
            <div class="resingInfoBlock">
                <span class="resingMes1">{{form.messege1}}</span>
            </div>
            <div class="resingDetailBlock">
                <div class="resingSubBlock">
                    <span class="mgr">{{text.jobClass}}</span>
                    <span>{{form.jobLevel}}</span>
                </div>
                <div class="mgt">{{text.mBaseSal}}</div>
                <div class="resingAnnotationBlock">
                    <div class="resingAnnotationFlxBlock">
                        <div>
                            <div class="tblock">
                                <div class="tblhead strL">&nbsp;</div>
                                <div class="tBodyRow strL">{{text.bfNum}}</div>
                                <div class="tBodyRow strL">{{text.cutRate}}</div>
                                <div class="strL">{{text.afNum}}</div>
                            </div>
                            <div class="tblock">
                                <div class="tblhead str">{{text.mTblClmBase}}</div>
                                <div class="tBodyRow deci">{{form.mTblClmBase}}</div>
                                <div class="tBodyRow str">{{form.cutRate}}</div>
                                <div class="deci">{{form.cTblClmBase}}</div>
                            </div>
                            <div class="tblock">
                                <div class="tblhead str"><span class="ministr">{{text.mTblClmMng}}</span></div>
                                <div class="tBodyRow deci">{{form.mTblClmMng}}</div>
                                <div class="tBodyRow str">-</div>
                                <div class="deci">{{form.cTblClmMng}}</div>
                            </div>
                            <div class="tblock">
                                <div class="tblhead str">{{text.mTblClmWrk}}</div>
                                <div class="tBodyRow deci">{{form.mTblClmWrk}}</div>
                                <div class="tBodyRow str">-</div>
                                <div class="deci">{{form.cTblClmWrk}}</div>
                            </div>
                            <div class="tblock">
                                <div class="tblhead str">{{text.mTblClmCls}}</div>
                                <div class="tBodyRow deci">{{form.mTblClmCls}}</div>
                                <div class="tBodyRow str">-</div>
                                <div class="deci">{{form.cTblClmCls}}</div>
                            </div>
                            <div class="tblock tblContAllTd">
                                <div class="tblhead str">{{text.mTblClmAll}}</div>
                                <div class="tBodyRow deci">{{form.mTblClmAll}}</div>
                                <div class="tBodyRow deci">&nbsp;</div>
                                <div class="deci">{{form.cTblClmAll}}</div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="resingWaBlock">
            <div>{{text.messege2b}}</div>
            <div>{{text.messege2c}}</div>
        </div>
        <div class="resingSignBlock">
            <span>{{form.singDate}}</span>
            <span class="signName">{{text.singName}}</span>
        </div>
    </div>
</v-main>
</template>

<script lang="ts">
    import Vue from 'vue';
    import lang from "../../lang";
    let text = new lang(0);
    import * as comm from '../../common';
    import {userData} from "../../types";
    import {MyResignSalaryItem} from "../../lib/api/api_response_type";
    import {strReplacePercentObject,getGengou,LoadingOverlay} from "../../common";
    import {apiRequest} from "../../lib/api";

    export default Vue.extend({
        mounted(){
            this.api = this.$store.state.apiSaver;
            this.resinData = this.$store.state.resinData as MyResignSalaryItem;
            const adate = new Date(this.resinData.adateRaw);
            const aGengou = getGengou(adate);
            this.form.userCode = this.resinData.userid;
            this.form.userName = strReplacePercentObject(this.text.namedono,{name:this.resinData.username});
            if(aGengou) this.form.messege1 = strReplacePercentObject(this.text.messege1a,{"gengou":aGengou.name,"year":aGengou.year,"month":(adate.getMonth()+1).toString()});
            this.form.jobLevel = this.resinData.jobLevel;
            this.form.mTblClmBase = this.resinData.mTblClmBase||"";
            this.form.mTblClmMng = this.resinData.mTblClmMng||"";
            this.form.mTblClmWrk = this.resinData.mTblClmWrk||"";
            this.form.mTblClmCls = this.resinData.mTblClmCls||"";
            this.form.mTblClmAll = this.resinData.mTblClmAll||"";
            const rdate = new Date(this.resinData.rdateRaw);
            const rGengou = getGengou(rdate);
            if(rGengou) this.form.singDate = strReplacePercentObject(this.text.singDate,{"gengou":rGengou.name,"year":rGengou.year,"month":(rdate.getMonth()+1).toString(),"date":rdate.getDate().toString()});
            this.form.cutRate = this.resinData.cutRate||"";
            this.form.cTblClmBase = this.resinData.cTblClmBase||"";
            this.form.cTblClmMng = this.resinData.cTblClmMng||"";
            this.form.cTblClmWrk = this.resinData.cTblClmWrk||"";
            this.form.cTblClmCls = this.resinData.cTblClmCls||"";
            this.form.cTblClmAll = this.resinData.cTblClmAll||"";
        },
        data: () => ({
            text : text.Text.resingForm.salary,
            mes : text.Text.messege,
            printStr:text.Text.print,
            resinData:undefined as undefined|MyResignSalaryItem,
            userData:{} as userData,
            form:{
                userCode:"",
                userName:"",
                messege1:"",
                messege2:"",
                jobLevel:"",
                singDate:"",
                mTblClmBase:"",
                mTblClmMng:"",
                mTblClmWrk:"",
                mTblClmCls:"",
                mTblClmAll:"",
                cutRate:"",
                cTblClmBase:"",
                cTblClmMng:"",
                cTblClmWrk:"",
                cTblClmCls:"",
                cTblClmAll:"",
            },
            api:null as null|{connection:boolean,apiRequest:null|apiRequest},
        }),
        methods:{
            async getPdf(){
                LoadingOverlay(this,true);
                if(this.api && this.api.connection && this.api.apiRequest){
                    const apiResponse = await this.api.apiRequest.request.my.printResinSalary();
                    if(apiResponse.statusCode === 200 && apiResponse.data.pdfdata){
                        LoadingOverlay(this,false);
                        comm.openPdfNewWindow(apiResponse.data.pdfdata.data)
                    }else if(apiResponse.statusCode === 401){
                        comm.invalidSession(this);
                    }else{
                        comm.ApiErrorMessege(this,comm.unknowError);
                    }
                }
            }
        },

    });
</script>

<style scoped>
.resingblock{
    margin: 0.5em 1em;
    padding: 0.5ch;
    border: solid 2px;
}
.resingTitle{
    text-align: center;
}
.resingSubBlock{
    display: flex;
    flex-direction: row;
}
.resingWaBlock{
    margin-top:2em;
    margin-left: 2ch;
}
.resingCd{
    text-align: center;
    margin-right: 2em;
}
.resingSimei{
    text-align: left;
}
.resingMainBlock{
    margin-top: 2em;
    margin-left: 4em;
}
@media (max-width:640px) {
    .resingMainBlock{
        margin-left: 0;
    }
}
.resingInfoBlock{
    display: flex;
    flex-direction: column;
}
.resingMes1{
    margin: 0;
}
.resingMes2{
    margin-left: 4em;
}
.resingDetailBlock{
    margin-top: 2em;
}
.resingDetailTbl{
    text-align: left;
    margin-left: 4em;
    margin-bottom: 2ch;
}
.resingDetailTbl th{
    font-weight: normal;
    padding-right: 2ch;
    min-width: 8ch;
}
.str{
    text-align: center;
}
.strL{
    text-align: left;
}
.tBodyRow{
    border-bottom: solid 1px;
}
.deci{
    text-align: right;
}
.resingAnnotationBlock{
    margin-left: 5ch;
}
.resingAnnotationTblBlock{
    border: solid 1px;
    padding: 0;
    width: fit-content;
}
.resingAnnotationFlxBlock{
    width: fit-content;
}
.resingAnnotationFlxBlock > div{
    display: flex;
    flex-wrap: wrap;
}
.resingAnnotationFlxBlock > div > div{
    border-style:solid;
    border-width: 1px;
    margin-left: -1px;
    margin-top: -1px;
    flex-grow: 1;
}
.resingAnnotationFlxBlock > div > .tblContAllTd{
    border-left: double 3px;
}
.resingAnnotationFlxBlock > div > div > div{
    padding: 0.25ch 0.5ch;
}
.resingAnnotationFlxBlock > div > div .tblhead{
    background-color: #CCC;
    border-bottom: 1px solid;
    height: 30px;
}
.resingAnnotationFlxBlock > div > .tblock{
    width: 150px;
    min-width: 150px;
    max-width: 150px;
}
.ministr{
    font-size: 16px;
    height: 30px;
    vertical-align: middle;
}
.resingSignBlock{
    margin-top: 4ch;
    display: flex;
}
.resingSignBlock .signName{
    margin-left: auto;
}
.mgr{
    margin-right: 4em;
}
.mgt{
    margin-top: 2ch;
}
</style>